import { render, staticRenderFns } from "./Abas.vue?vue&type=template&id=55ebf80e&scoped=true&lang=pug"
import script from "./Abas.vue?vue&type=script&lang=js"
export * from "./Abas.vue?vue&type=script&lang=js"
import style0 from "./Abas.styl?vue&type=style&index=0&id=55ebf80e&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ebf80e",
  null
  
)

export default component.exports